import React from 'react';

const OverflowContainer = (props) => {
    return <div style={{ paddingBottom: '100px' }}>{props.children}</div>;
};

export default OverflowContainer;
